// Close quick shop option 2 inline picker after successful add to cart
(function() {
  // Patch Shopify.addItem to close the inline quick shop picker on success
  var patchInterval = setInterval(function() {
    if (typeof Shopify === 'undefined' || typeof Shopify.addItem === 'undefined') return;
    clearInterval(patchInterval);
    var origAddItem = Shopify.addItem;
    Shopify.addItem = function(variantId, qty, callback, properties) {
      var wrappedCallback = function() {
        // Close any open quick shop option 2 inline pickers
        var openPickers = document.querySelectorAll('.product-item.quickshop-popup-show');
        openPickers.forEach(function(el) {
          el.classList.remove('quickshop-popup-show');
        });
        if (typeof callback === 'function') {
          callback.apply(this, arguments);
        }
      };
      return origAddItem.call(this, variantId, qty, wrappedCallback, properties);
    };
  }, 50);
})();
